import { Build, forceUpdate, h, Host, readTask } from "@stencil/core";
import { Breakpoints, MobileUtility } from "../../service/mobile-utility";
export class TabsAccordion {
    constructor() {
        this.isMobile = true;
        this.tabs = [];
        this.viewportChangedListener = (breakpoint) => this.onBreakpointChange(breakpoint);
    }
    componentWillLoad() {
        if (Build.isBrowser) {
            MobileUtility.addViewportChangedListener(this.viewportChangedListener);
        }
    }
    componentDidLoad() {
        this.initTabs();
    }
    onTabAdded() {
        readTask(() => this.initTabs());
    }
    onTabRemoved() {
        readTask(() => this.initTabs());
    }
    onTabMutated() {
        forceUpdate(this.el);
    }
    initTabs() {
        this.tabs = Array.from(this.el.querySelectorAll('uvex-tab'));
    }
    onBreakpointChange(breakpoint) {
        switch (breakpoint) {
            case Breakpoints.MOBILE:
            case Breakpoints.TABLET:
                this.isMobile = true;
                break;
            case Breakpoints.DESKTOP:
            case Breakpoints.LARGE_DESKTOP:
            case Breakpoints.EXTRA_LARGE_DESKTOP:
                this.isMobile = false;
                break;
        }
    }
    renderAccordion() {
        if (!this.isMobile || this.tabs.length === 0) {
            return;
        }
        return (h("uvex-accordion", { scrollOnChange: true }, this.tabs.map((tab, index) => {
            return h("uvex-collapse", { isOpen: index === 0 ? true : false }, h("a", { class: "collapse-headline", role: "button", "collapse-trigger": true }, tab.getAttribute('label'), h("svg", { width: "20", height: "20" }, h("use", { href: "#fa-chevron-down" }))), h("div", { class: "collapse-content", innerHTML: tab.innerHTML }));
        })));
    }
    render() {
        return (h(Host, { key: '6f975872c436afefe37004f8e7ae3cc8f99536d0' }, this.renderAccordion(), h("div", { key: '89dc61c8983369ec9c89f75b745c745e8e3940e6', hidden: this.isMobile }, h("slot", { key: '8b858d15a8a59130a06df25bd8e6693fdfd70171' }))));
    }
    static get is() { return "uvex-tabs-accordion"; }
    static get originalStyleUrls() {
        return {
            "$": ["./tabs-accordion.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["tabs-accordion.css"]
        };
    }
    static get states() {
        return {
            "isMobile": {},
            "tabs": {}
        };
    }
    static get elementRef() { return "el"; }
    static get listeners() {
        return [{
                "name": "uvexTabAdded",
                "method": "onTabAdded",
                "target": undefined,
                "capture": false,
                "passive": false
            }, {
                "name": "uvexTabRemoved",
                "method": "onTabRemoved",
                "target": "document",
                "capture": false,
                "passive": true
            }, {
                "name": "uvexTabMutated",
                "method": "onTabMutated",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
//# sourceMappingURL=tabs-accordion.js.map
